enum Standard {
    LOW = 'Low',
    MEDIUM = 'Medium',
    HIGH = 'High'
}

export default Standard;